import React from 'react';
import clsx from 'clsx';
import { XIcon } from '../icon/XIcon';
import { isBoolean } from '../../../util/isBoolean';
export var XAlertType;
(function (XAlertType) {
    XAlertType["DEFAULT"] = "DEFAULT";
    XAlertType["SUCCESS"] = "SUCCESS";
    XAlertType["WARNING"] = "WARNING";
    XAlertType["ERROR"] = "ERROR";
})(XAlertType || (XAlertType = {}));
export function XAlert(_a) {
    var _b;
    var icon = _a.icon, type = _a.type, children = _a.children;
    type = type !== null && type !== void 0 ? type : XAlertType.DEFAULT;
    var iconValue;
    if (isBoolean(icon)) {
        iconValue =
            (_b = {},
                _b[XAlertType.WARNING] = 'warning',
                _b[XAlertType.ERROR] = 'error',
                _b[XAlertType.SUCCESS] = 'check',
                _b)[type] || icon;
    }
    else {
        iconValue = icon;
    }
    return (React.createElement("div", { className: clsx('XAlert', type, { hasIcon: Boolean(iconValue) }) },
        iconValue && (React.createElement("div", { className: "icon-container" },
            React.createElement(XIcon, null, iconValue))),
        React.createElement("div", { className: "alert-content" },
            React.createElement("div", null, children))));
}
